import { render, staticRenderFns } from "./stalllist.vue?vue&type=template&id=529f3bbd&scoped=true"
import script from "./stalllist.vue?vue&type=script&lang=js"
export * from "./stalllist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f3bbd",
  null
  
)

export default component.exports